import {Configuration} from '../api'

export const PUBLIC_RECAPTCHA_KEY = '6LeN1OcUAAAAACGHK_wHWQNG4Sef_49nLH3jF9JQ'

export const STANDARD_API_CONFIGURATION = new Configuration({
    credentials: 'include',
})
